<template>
  <card-info-component
    :title="$t('pages.planning.widgets.hour_balance')"
    :value="hourBalance"
    :is-loading="!userData"
    icon="fa-clock"
    tone="teal"
  ></card-info-component>
</template>

<script>
import { CardInfoComponent } from "@/pages/components";
import { mapGetters } from "vuex";

export default {
  components: {
    CardInfoComponent,
  },
  computed: {
    ...mapGetters("auth", ["hourBalance", "userData"]),
  },
};
</script>

<style scoped></style>
